

export default {
  light: {
    primary: "#536DFE",
    secondary: "#FF5C93",
    error: "#FF4081",
    warning: "#FFC260",
    success: "#3CD4A0",
    info: "#9013FE",
    blue:"#7011FE",
    orange:"#FAD260",
    textColor: "#FFF3F359",
    iconColor: "#FFFFFF59",
    grayBold: "#4A4A4A",
    gold:"#33ED",
    wait:"#B23432",
    cancel:"#3Cd",
      
  },  
 
};
